import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody, Label, Input, FormFeedback } from "reactstrap";
import ReactFlagsSelect from "react-flags-select";
import { Link, useHistory } from "react-router-dom";

import Select from "react-select";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';


const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: '#ffffff',
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? '#036B41'
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? '#fff'
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const Edit_user = props => {
  //meta title
  document.title = "Edit User";
  const history = useHistory();
  const { getRequest, postRequest } = useRequests();


  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};


  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      country_code: 'ES',
      country: {label: 'Spain', value: 'Spain'},
    },
    validationSchema: Yup.object({
      first_name: Yup.string()
        .required('First Name is required'),
      last_name: Yup.string()
        .required('Last Name is required'),
      phone: Yup.string()
        .matches(
          /^[#0-9]+$/,
          'Please enter a valid value!'
        )
        .required('Mobile Number is required')
        .test(
          'len',
          'Mobile numbers should not be greater than 10 digits!',
          function (value) {
              return value ? value.length <= 10 : false; // Ensure the number is not greater than 10 digits
          }
      ),
      country_code: Yup.string().required('Please select country code'),
      country: Yup.object().shape({
          label: Yup.string().required('Please select a country'),
          value: Yup.string().required('Please select a country'),
        }).required('Please select a country'),
    }),
    onSubmit: async (values) => {
      try {
        let temp_country_code = AllCountriesCustomData.find(element => element.code === values.country_code);

        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          u_id: atob(props.match.params.id),
          first_name: values.first_name,
          last_name: values.last_name,
          country: values.country.value,
          country_code: temp_country_code.phone_code,
          phone: values.phone,
        });
        const res = await postRequest('update-user', jsonpar);
        if (res && res.code === 200) {
          history.push({
            pathname: '/user_management',
            state: { code: 200, status: 'success', message: res.message }
          });
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Update';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [AllCountriesData, setAllCountriesData] = React.useState([]);
  const [AllCountriesCustomData, setAllCountriesCustomData] = React.useState([]);
  const handleLoadGetAllCountries = async () => {
    const res = await getRequest('get-all-countries');
    if (res && res.code === 200) {
      let originalText = res.data;

      let tempArr = [];
      originalText.forEach(element => {
        let temp = {
            label: element.country_name,
            value: element.country_name,
        };
        tempArr.push(temp);
      });
      tempArr = [{
          options: tempArr
      }];
      setAllCountriesData(tempArr);

      tempArr = [];
      originalText.forEach(element => {
        let temp = {
            code: element.country_code,
            label: element.country_code + ' +' + element.phone_code,
            phone_code: element.phone_code,
        };
        tempArr.push(temp);
      });
      setAllCountriesCustomData(tempArr);

      handleLoadGetUserInfo(originalText);
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }
  
  const handleLoadGetUserInfo = async (TempAllCountriesCustomData) => {
    const jsonpar = JSON.stringify({
      u_id: atob(props.match.params.id)
    });
    const res = await postRequest('get-user-info', jsonpar);
    if (res && res.code === 200) {
      let originalText = res.data;
      
      let temp_country_code = TempAllCountriesCustomData.find(element => element.phone_code === originalText.country_code);

      validation1.setValues({
        ...validation1.values,
        first_name: originalText.first_name,
        last_name: originalText.last_name,
        email: originalText.email,
        country: {label: originalText.country, value: originalText.country},
        phone: originalText.phone,
        country_code: temp_country_code.country_code,
      });
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

  React.useEffect(() => {
    if (!props.match.params.id) {
      history.push({
        pathname: '/user_management',
        state: { code: 401, status: 'error', message: 'ID not found! Please provide a valid ID.' }
      });
		}
    else {
      handleLoadGetAllCountries();
    }
  }, []);

  
  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("Edit User")} />
          <Card>
            <CardBody>
              <Row>
                <Col md={6} xs="12">
                  <div className="mb-3">
                    <Label className="form-label">First name :</Label>
                    <Input 
                      name="first_name" 
                      type="text" 
                      placeholder={'Enter first name'}
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      value={validation1.values.first_name || ""}
                      invalid={
                        validation1.touched.first_name && validation1.errors.first_name ? true : false
                      }
                    />
                    {validation1.touched.first_name && validation1.errors.first_name ? (
                      <FormFeedback type="invalid">{validation1.errors.first_name}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col md={6} xs="12">
                  <div className="mb-3">
                    <Label className="form-label">Last name :</Label>
                    <Input
                      name="last_name" 
                      type="text" 
                      placeholder={'Enter last name'}
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      value={validation1.values.last_name || ""}
                      invalid={
                        validation1.touched.last_name && validation1.errors.last_name ? true : false
                      }
                    />
                    {validation1.touched.last_name && validation1.errors.last_name ? (
                      <FormFeedback type="invalid">{validation1.errors.last_name}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col md={6} xs="12">
                  <div className="mb-3">
                    <Label className="form-label">Email :</Label>
                    <Input
                      name="email" 
                      type="email" 
                      placeholder={'Enter email'}
                      value={validation1.values.email || ""}
                      readOnly
                    />
                  </div>
                </Col>
                <Col md={6} xs="12">
                  <div className="mb-3 Register-Select2">
                    <Label className="form-label">Select country :</Label>
                    <Select styles={colourStyles} value={validation1.values.country} onChange={(e) => validation1.setValues({ ...validation1.values, country: e })} options={AllCountriesData} classNamePrefix="select2-selection" />
                    {validation1.touched.country && validation1.errors.country ? (
                      <FormFeedback type="invalid">{validation1.errors.country}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
                {/* <Col md={6} xs="12">
                  <div className="mb-3">
                    <Label className="form-label">Profile Picture :</Label>
                    <Input type="file" placeholder="" className="fileUpload" id="formFile" />
                  </div>
                </Col> */}
                <Col md={6} xs={12}>
                  <div className="mb-3 signupCountry">
                    <Label>Mobile no. :</Label>
                    <ReactFlagsSelect
                      placeholder={'Select country code'}
                      countries={AllCountriesCustomData.map(country => country.code)}
                      customLabels={AllCountriesCustomData.reduce((acc, country) => {
                        acc[country.code] = country.label;
                        return acc;
                      }, {})}
                      name="country_code" selected={validation1.values.country_code} onSelect={(e) => validation1.setValues({ ...validation1.values, country_code: e })}
                    />
                    <Input
                      name="phone"
                      type="text" 
                      placeholder={'Enter mobile number'}
                      onChange={validation1.handleChange}
                      onBlur={validation1.handleBlur}
                      value={validation1.values.phone || ""}
                      invalid={
                        validation1.touched.phone && validation1.errors.phone ? true : false
                      }
                    />
                    {validation1.touched.country_code && validation1.errors.country_code ? (
                      <FormFeedback type="invalid">{validation1.errors.country_code}</FormFeedback>
                    ) : null}
                    {validation1.touched.phone && validation1.errors.phone ? (
                      <FormFeedback type="invalid">{validation1.errors.phone}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <div className="text-left mt-2">
                  <button type="button" 
                    id="submit1"
                    onClick={(e) => {
                      e.preventDefault();
                      validation1.handleSubmit();
                      return false;
                    }}
                  className="btn btn-primary me-2">Update</button>
                  <Link to="/user_management" className="btn btn-light me-2">Cancel</Link>
                </div>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Edit_user);
